import { HealthDocumentationFileRef } from '../Interfaces/HealthDocumentationFileRef.interface';

/** The part of a documentation file (GraphQL `DocumentationFile`) the reference is made of. */
interface DocumentationFileLike {
	id: string;
	folderId?: string | null;
	name?: string | null;
	displayName?: string | null;
	extension?: string | null;
	file?: { name?: string | null; extension?: string | null } | null;
}

export const toHealthDocumentationFileRef = (
	file: DocumentationFileLike,
	folderName: string,
	fallbackName?: string,
): HealthDocumentationFileRef => ({
	id: file.id,
	folderId: file.folderId ?? '',
	folderName,
	name:
		file.displayName ||
		file.name ||
		fallbackName ||
		file.file?.name ||
		'soubor',
	extension: (file.file?.extension || file.extension || '').toLowerCase(),
});
